import { Component, EventEmitter, Input, Output } from '@angular/core';

import { HelpersInterface } from '../../../../core/interfaces';
import { MainDashboardInterface } from '../../models';
@Component({
  selector: 'app-main-top',
  templateUrl: './main-top.component.html',
  styleUrls: ['./main-top.component.scss'],
  standalone: false
})
export class MainTopComponent {
  @Input() public titleSide = '';
  @Input() public selectedActivity = '1';
  @Input() public heightContent = 'auto';
  @Input() public filterItems: MainDashboardInterface.IMainDashboardFilterModel[] = [];
  @Input() public side: string;
  @Input() public activityItems: HelpersInterface.SelectItemHelper[] = [];

  @Input() public tableHeight = 650;
  @Input() public builderItems: MainDashboardInterface.IBuilderItems[] = [];

  @Output() public expandTable = new EventEmitter<void>();
  @Output() public changeToggle = new EventEmitter<string>();
  @Output() public changeFilter = new EventEmitter<MainDashboardInterface.IFilterItem>();
  @Output() public changeActivity = new EventEmitter<string>();
  @Output() public searchEmitter = new EventEmitter<string>();
  @Output() public createEndpoint = new EventEmitter<void>();
  @Output() public downloadTable = new EventEmitter<void>();
  @Output() public changeBuilder = new EventEmitter<{ attr: string; label: string; active: boolean; }[]>();

  protected titleView = 'Endpoints';
  protected isActive = false;
  protected filterVal = '';

  private timer: any;

  constructor() { }

  protected onChangeToggleHandler(value: any): void {
    this.titleView = value ? 'Companies' : 'Endpoints';
    this.changeToggle.emit(this.titleView);
  }

  protected getButtonLabel(side: string): string {
    return `buttonDownloadDashboardInfo${side}`;
  }

  protected getSwitchLabel(side: string): string {
    return `changeViewSwitch${side}`;
  }

  protected onExpandTableHandler(): void {
    this.expandTable.emit();
  }

  protected onDownloadHandler(): void {
    this.downloadTable.emit();
  }

  protected onChangeActivityHandler(value: string): void {
    this.selectedActivity = value;
    this.changeActivity.emit(value);
  }

  protected onChangeFilterHandler(value: MainDashboardInterface.IFilterItem): void {
    this.changeFilter.emit(value);
  }

  protected onCreateEndpointButtonClickHandler(): void {
    this.createEndpoint.emit();
  }

  protected onSearchHandler(event: Event, to = false) {
    this.filterVal = (event.target as HTMLInputElement).value;

    if (to) {
      clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.searchEmitter.emit(this.filterVal.toLowerCase());
      }, 600);
    } else {
      this.searchEmitter.emit(this.filterVal.toLowerCase());
    }
  }

  protected onOptionChangeHandler(value: {
    attr: string;
    label: string;
    active: boolean;
  }[]): void {
    this.changeBuilder.emit(value);
  }
}
